export default class Form {
  public name!: string
  public email!: string
  public body!: string
  public privacy?: boolean
  public recaptcha?: string
  public form!: string
  public subject?: string
  public attachment?: File

  public constructor(form: string, subject: string) {
    this.name = ''
    this.email = ''
    this.body = ''

    this.privacy = false
    this.form = form
    this.subject = subject
  }

  setRecaptcha(recaptcha: string) {
    this.recaptcha = recaptcha
  }
}
